<template>
  <section id="section__documentsLimit">
    <StaticGuide>
      <template #logo><span></span></template>
      <template #contents>
        <v-row no-gutters class="py-8" :class="{ 'text-left': referralCode }">
          <v-col cols="12">
            <p class="font--p-3">
              <template v-if="referralCode">
                서류 제출이 완료되었어요<br />
                계약서를 작성해주세요
              </template>
              <template v-else> 이제 계약서 작성만 남았어요. </template>
            </p>
            <p v-if="referralCode" class="text-left">
              계약서 작성이 완료되면<br />
              카드사 입금 계좌 변경 후 서비스가 시작돼요
            </p>
          </v-col>
        </v-row>

        <v-row no-gutters class="mb-10">
          <v-col cols="12">
            <img src="@/assets/images/apply/folder.png" class="folder" />
          </v-col>
        </v-row>

        <v-row v-if="!referralCode" no-gutters class="mb-10">
          <v-col cols="12">
            <p class="font-size--18 color--nice">
              계약서 작성하고 <br />
              서비스를 시작 하세요!
            </p>
          </v-col>
        </v-row>
      </template>

      <template #activator>
        <v-row no-gutters>
          <v-col cols="12">
            <BasicButton @click="next()">계약서 작성하기</BasicButton>
          </v-col>
        </v-row>
      </template>
    </StaticGuide>
  </section>
</template>
<script>
import StaticGuide from '@/components/common/guide/StaticGuide.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    StaticGuide,
  },
  computed: {
    ...mapGetters('auth', ['referralCode']),
    ...mapGetters('myfinbiz', ['platformName']),
  },
  methods: {
    next() {
      this.$emit('emitResult', true)
    },
  },
}
</script>
<style lang="scss" scoped>
#section__documentsLimit {
  text-align: center;

  .folder {
    width: 100%;
    height: 200px;
    object-fit: contain;
  }
}
</style>
